// import {jwtDecode, JwtPayload} from "jwt-decode";

export const getToken = () => {
    return localStorage.getItem('token') || '';
};
export const setUser = (data: any) => {    
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.data));
};
export const getUser = () => {
    try {
        var user = JSON.parse(localStorage.getItem('user') || 'null');
    } catch (error) {
        return {}
    }
    if (!user) {
        return {};
    }
    // const {user_id}: any = _getTokenData();
    return {...user}
};
export const removeUser = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};
// const _getTokenData = () => {
//     const token: string = localStorage.getItem('token') || '';
//     if (!token) {
//         return {};
//     }
//     return jwtDecode<JwtPayload>(token);
// };

// export const isValidToken = () => {
//     const decoded: any = _getTokenData();
//     if (!decoded.exp) {
//         return false;
//     }
//     return new Date(decoded.exp * 1000).getTime() > new Date().getTime();
// };